module.exports = __webpack_public_path__ + "selector-icon.png?c7317ff715c55473768d2ec63fa9272b";